import { useParams } from 'react-router';
import UnAuthorizedMessage from '@/components/Permission/UnauthorizedMessage';
import ErrorCard from '@/components/UI/ErrorCard';
import { formConfigurationMapping, type TFormConfig } from '@/features/ApplicationForm/FormConfig';
import { useApplicationForm, useApplications } from '@/hooks/ReactQueryHooks/useApplicationFromQuery';
import { usePermission } from '@/hooks/usePermission';
import { EPermission } from '@/types/Permission';
import { ApplicationNav } from '../ApplicationNav';

export const ApplicationFormDashboard = () => {
  const { applicationFormId } = useParams<string>();
  const { hasPermission } = usePermission();

  const fetchApplicationForm = useApplicationForm({
    formId: applicationFormId!,
  });
  const applicationForm = fetchApplicationForm?.data?.data;

  const applicationFromConfig = formConfigurationMapping.find((fcm) => fcm.formCode === applicationForm?.templateCode) as TFormConfig;

  const fetchApplications = useApplications({
    formId: applicationFormId!,
    params: { perPage: 500 },
  });
  const data = fetchApplications?.data;

  // if (!applicationFromConfig?.applicationDashboardComponent) {
  //   return <h1>No Dashboard component found</h1>;
  // }

  if (!hasPermission([EPermission.READ_APPLICATION_FORM_DASHBOARD])) {
    return <UnAuthorizedMessage title='Unauthorized' message='You do not have permission to view this application form dashboard.' />;
  }

  return (
    <>
      <ApplicationNav />
      <div className='flex justify-center'>
        {/* {!applicationFromConfig?.applicationDashboardComponent && <h1>No Dashboard component found</h1>} */}
        {fetchApplicationForm.isLoading && <h2>Loading...</h2>}
        {fetchApplicationForm.isError && (
          <ErrorCard
            errorMsg='Oops! Something went wrong. We are trying to fix it as soon as possible. Please visit us again later.'
            errorTitle='Error'
          />
        )}
        {/* {!applicationFromConfig && !fetchApplicationForm.isLoading && (
        <h2>Application Dashboard not found</h2>
      )} */}
        {data && !applicationFromConfig?.applicationDashboardComponent && (
          <div className='flex items-center h-screen/2 w-full'>
            <ErrorCard
              errorMsg='Oops! This dashboard is currently under construction. Please check back soon.'
              errorTitle='Dashboard Under Construction'
            />
          </div>
        )}
      </div>
      {data && applicationFromConfig?.applicationDashboardComponent && <applicationFromConfig.applicationDashboardComponent data={data} />}
    </>
  );
};
